module.exports = __webpack_public_path__ + "img/SES_8738001.d544b48a.jpg";